import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./stores/loginSlice";
import { merchantAPI } from "./stores/paylaterAPI";
import paylaterReducer from "./stores/paylaterSlice";
import propertyReducer from "./stores/propertySlice";
export default () =>
  configureStore({
    reducer: {
      property: propertyReducer,
      login: loginReducer,
      paylater: paylaterReducer,
      [merchantAPI.reducerPath]: merchantAPI.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(merchantAPI.middleware),
    devTools: process.env.NODE_ENV !== "production",
  });
